module.exports = __webpack_public_path__ + "assets/img/lance.9d5ce75d.png";